export enum QualificationOutcome {
    Unknown = 'Unknown',
    AlreadyCustomer = 'AlreadyCustomer',
    Interested = 'Interested',
    NonInterested = 'NonInterested',
    Expired = 'Expired',
    NeverReplied = 'NeverReplied',
    Spam = 'Spam',
    Unfitting = 'Unfitting'
}